module.exports = __webpack_public_path__ + "img/9791158790684.64c71061.jpg";